import { Link } from "react-router-dom"

/**
 * 404-Seite (P3 aus MASCHINEN_STRUKTURVERGLEICH.md) — ersetzt den stummen
 * Catch-all-Redirect auf /dashboard, der unbekannte Routen kommentarlos
 * verschluckte und den Eindruck "lässt sich nicht navigieren" verstärkte.
 */
export function NotFoundPage() {
  return (
    <div className="flex flex-col items-center justify-center py-24 text-center">
      <p className="text-sm font-medium text-slate-400">Fehler 404</p>
      <h1 className="mt-2 text-2xl font-semibold text-slate-900">Seite nicht gefunden</h1>
      <p className="mt-2 max-w-md text-sm text-slate-600">
        Diese Adresse existiert nicht (mehr) oder wurde falsch eingegeben.
      </p>
      <Link
        to="/dashboard"
        className="mt-6 rounded-lg bg-slate-900 px-4 py-2 text-sm font-medium text-white hover:bg-slate-700"
      >
        Zur Übersicht
      </Link>
    </div>
  )
}
